import i18next from 'i18next'
import {SelectItem} from '@/components/dumb/Select'
import {Role} from './Role'
import {TeammateStatus} from '@/stores/team-management/constants/TeammateStatus'
export const teamManagementAllTab = () => [
    {
        title: i18next.t('team-management.tabs.all'),
        key: TeammateStatus.ok
    }
]

export const roleSelectOptions: () => SelectItem[] = () => [
    ...Object.keys(Role).map((key) => ({
        value: Role[key],
        label: i18next.t(`team-management.roles.${key}`)
    }))
]
